import { type Components, type CssVarsTheme, alpha } from '@mui/material/styles';

export const MuiAppBar: Components<CssVarsTheme>['MuiAppBar'] = {
  defaultProps: {
    color: 'transparent'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: 'none',
      backdropFilter: 'blur(6px)',
      backgroundColor: alpha(theme.palette.background.default, 0.8),
      transition: 'height 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    })
  }
};
